module.exports = __webpack_public_path__ + "static/img/about_logo_01_zh.d160ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_logo_01_zh.png
// module id = Z1dS
// module chunks = 34